<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard">
    <div class="vx-row match-height">

      <div class="vx-col w-full mb-3" v-if="gift">
        <vs-alert color="warning" active="true" icon-pack="feather" icon="icon-star">
          {{$t('GiftMessage',{date:gift.expired})}}
          <countdown :time="time" :interval="100">
            <template slot-scope="props">
                  {{ props.days }} {{$t('day')}} - {{ props.hours }} {{$t('hours')}} - {{ props.minutes }} {{$t('minutes')}}
                  - {{ props.seconds }}.{{ Math.floor(props.milliseconds / 100) }} {{$t('seconds')}}
            </template>
          </countdown>
        </vs-alert>
      </div>
      <div class="vx-col w-full mb-3" v-if="generalInfo.alert && generalInfo.alert.status && alertList.length>0"
                v-for="(item,index) in alertList">
        <vs-alert :color="item.color" :active.sync="alertListActive[index]" icon-pack="feather" :icon="item.icon ? item.icon.replace('feather','icon') :'icon-alert-triangle'"
                  :closable="item.fixed == 'unfixed'" close-icon="icon-x">
          {{item.msg}}
        </vs-alert>
      </div>


      <!-- CARD 1: CONGRATS -->
      <div class="vx-col lg:w-1/2 w-full mb-base" id="level-info">
        <vue-skeleton-loader v-if="!levelInfo" animation="fade" type="rect" rounded width="100%" height="600px"/>
        <vx-card v-else class="greet-user">

          <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
          <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">

          <div class="text-center mt-2">
            <feather-icon icon="AwardIcon" class="p-6 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          </div>

          <div class="text-center mt-2">
            <i v-for="(item, index) in activeUserInfo.level" class="feather icon-star-on text-warning text-2xl"></i>
            <i v-for="(item, index) in 5-activeUserInfo.level" class="feather icon-star text-2xl"></i>
            <p class="text-xl font-semibold">
              {{$t('Level')}} {{ $t(activeUserInfo.level) }}<span v-if="activeUserInfo.level == 5" class="ml-1">(vip)</span>
            </p>
          </div>
          <h2 class="my-3 text-center">{{$t('Hi')}} {{ activeUserInfo.name_display }}{{$t(',')}} {{$t('Welcome')}}!</h2>

          <vs-divider />
          <h4 class="mb-4">{{$t('Your level profile')}}</h4>

          <table class="w-full">
            <tr>
              <td class="font-semibold">{{$t('Daily withdrawal of tomans')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light align-middle">
                {{(usageLevel.daily_withdrawal_toman).toLocaleString('en-US')}}
                {{$t('out of')}}
                {{parseInt(levelInfo.dailyWithdrawalTomans).toLocaleString('en-US')}}
                {{$t('toman')}}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Daily withdrawal of crypto')}}</td>
              <td class="border-2 border-solid border-t-0 border-l-0 border-r-0 pl-2 d-theme-border-grey-light">
                <span v-if="levelInfo.dailyWithdrawalCrypto == 0">
                  {{$t('It is not possible to withdraw cryptocurrency at this level.')}}
                </span>
                <span v-else>
                  {{$t('Equivalent')}}
                  {{(usageLevel.daily_withdrawal_crypto).toLocaleString('en-US')}}
                  {{$t('out of')}}
                  {{parseInt(levelInfo.dailyWithdrawalCrypto).toLocaleString('en-US')}}
                   {{$t('toman')}}
                </span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('wage')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light">
                <span class="text-xl font-semibold">%{{levelInfo.feeBuy}}</span>
                <span v-if="gift"> <br>
                  <i18n path="wageGiftBuy">
                    <span class="text-danger font-semibold" place="percent">{{'%'+(levelInfo.feeBuyWithGift)}}</span>
                  </i18n>
                </span>
              </td>
            </tr>
            <!--
            <tr>
              <td class="font-semibold">{{$t('wage of sales')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light">
                <span class="text-xl font-semibold">%{{levelInfo.feeSell}}</span>
                <span v-if="gift"> <br>
                  <i18n path="wageGiftSell">
                    <span class="text-danger font-semibold" place="percent">{{'%'+(levelInfo.feeSellWithGift)}}</span>
                  </i18n>

                </span>
              </td>
            </tr>
            -->
            <tr>
              <td class="font-semibold">{{$t('Daily deposit of Tomans')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light align-middle">
                {{(usageLevel.daily_deposit_toman).toLocaleString('en-US')}}
                {{$t('out of')}}
                {{parseInt(levelInfo.dailyDeposit_toman).toLocaleString('en-US')}}
                {{$t('toman')}}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Daily deposit of Crypto')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light align-middle">
                {{$t('Unlimited')}}
              </td>
            </tr>
            <!--
            <tr>
              <td class="font-semibold">{{$t('Monthly withdrawals of Tomans and Crypto')}}</td>
              <td class="border-2 border-solid border-t-0 border-r-0 border-l-0 pl-2 d-theme-border-grey-light align-middle">
                {{$t('Equivalent')}}
                {{(usageLevel.monthly_withdrawal).toLocaleString('en-US')}}
                {{$t('out of')}}
                {{parseInt(levelInfo.monthlyWithdrawal).toLocaleString('en-US')}}
                {{$t('toman')}}
              </td>
            </tr>
            -->

          </table>
          <p class="mt-4 text-justify" v-if="levelInfo.dailyWithdrawalCrypto == 0">
            {{$t('This level, it is not possible to withdraw cryptocurrencies, but there is not much restriction for withdrawing and depositing Tomans compared to other levels.',
            {level:$t(activeUserInfo.level) })}}
          </p>
          <vs-divider/>
          <div class="mt-5 flex flex-wrap">
            <p class="mt-3">{{$t('Watch the tutorial video in this section.')}}</p>
            <vs-button color="warning" :href="videoLearn.level" target="_blank" class="ml-auto" type="border"  icon-pack="feather" icon="icon-play">{{$t('Watch the video')}}</vs-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col lg:w-1/2 w-full mb-base">
        <vue-skeleton-loader v-if="!pieChartData" animation="fade" type="rect" rounded width="100%" height="100%"/>
        <WalletChart v-else :pieChartData="pieChartData" :sumBalancePerInternal="sumBalancePerInternal" :gift="gift" :levelInfo="levelInfo"
                     :balanceWalletInternal="balanceWalletInternal" :sumBalancePerDollar="sumBalancePerDollar"></WalletChart>
      </div>

    </div>





    <!-- CARD 2: Crypto Slides -->
    <CryptoSlides class="mb-base" :candleSticks="candleSticks"/>


    <div class="mb-base" v-if="isUserLoggedIn">
        <openTrade/>
    </div>

    <vs-popup :title="$t('notice')" id="popup" :active.sync="popupActive">
      <div v-if="generalInfo.popup" v-html="generalInfo.popup.contentPopup"></div>
    </vs-popup>


  </div>
</template>

<i18n locale="fa">
{
  "GiftMessage": "شما یک طرح تخفیف فعال تا تاریخ {date} دارید. زمان باقی مانده تا پایان تخفیف:"

  ,"In this section, you will see the specifications of your user level.":
  "در این بخش مشخصات سطح کاربری خود را مشاهده میکنید."

  ,"Account level": "سطح حساب کاربری"
  ,"GiftCalculation": "قبل فعال کردن طرح {before}% بوده است ({percent} تخفیف)"
  ,"Unlimited":"نامحدود"
  ,"Daily deposit of Crypto":"واریز روزانه رمزارز"

  ,"Your level profile":"مشخصات سطح کاربری شما"
  ,"out of":"از"
  ,"Daily withdrawal of tomans":"برداشت روزانه تومان"
  ,"Daily withdrawal of crypto":"برداشت روزانه رمز ارز"
  ,"It is not possible to withdraw cryptocurrency at this level.":"در این سطح امکان برداشت رمز ارز وجود ندارد."
  ,"wage of buy":"کارمزد خریدها"
  ,"wage of sales":"کارمزد فروش ها"
  ,"wageGiftBuy":"در حال حاضر با فعال بودن طرح تخفیف بر روی حساب شما، کارمزد خرید ها {percent} محاسبه میشود."
  ,"wageGiftSell":"در حال حاضر با فعال بودن طرح تخفیف بر روی حساب شما، کارمزد فروش ها {percent} محاسبه میشود."
  ,"Daily deposit of Tomans":"واریز روزانه تومان"
  ,"Monthly withdrawals of Tomans and Crypto":"مجموع برداشت ماهانه تومان و رمزارز"
  ,"This level, it is not possible to withdraw cryptocurrencies, but there is not much restriction for withdrawing and depositing Tomans compared to other levels.":
    "در سطح {level} امکان برداشت رمزارز وجود ندارد اما محدودیت زیادی برای برداشت و واریز تومانی نسبت به بقیه سطح ها اعمال نشده است."
}
</i18n>
<i18n locale="en">
{
  "GiftMessage": "You have an active gift plan up to {date}. Time left until the end of the discount:"
  ,"wageGiftBuy":"At the moment, with the discount plan active on your account, the purchase commission is calculated {percent}."
  ,"wageGiftSell":"Currently, with the discount plan active on your account, the sales commission is calculated at{percent}."

}
</i18n>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import CryptoSlides from './CryptoSlides.vue'
import WalletChart from './EchartsPieChartWallet.vue'
import axios from '../../axios'
import countdown from '@chenfengyuan/vue-countdown'
import openTrade from '../trades-open/OpenTrades'
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
  data () {
    return {
      gift: null,
      levelInfo: null,
      pieChartData: null,
      sumBalancePerInternal: null,
      balanceWalletInternal: null,
      sumBalancePerDollar: null,
      candleSticks: null,
      usageLevel: null,
      popupActive:false,
      alertListActive:[],
      interval: null,
    }
  },

  components: {
    VueApexCharts,
    StatisticsCardLine,
    CryptoSlides,
    WalletChart,
    countdown,
    openTrade,
    VueSkeletonLoader
  },
  methods:{
    getInfo(){
      if(this.isUserLoggedIn){
        var self = this;
        axios.post('/dashboard')
          .then(function (response) {
            response.data.id = self.activeUserInfo.id;
            self.setData(response.data);
            localStorage.setItem('dashboard', JSON.stringify(response.data))
          })
      }
    },
    setData(data){
      this.gift = data.gift
      this.levelInfo = data.level_info
      this.pieChartData = data.balance_pie_chart
      this.sumBalancePerInternal = data.sum_balance_internal
      this.balanceWalletInternal = data.balance_wallet_internal
      this.sumBalancePerDollar = data.sum_balance_dollar
      this.candleSticks = data.candle_sticks
      this.usageLevel = data.usage_level
    },
  },
  mounted () {
    if(this.generalInfo.popup){
      var popup = localStorage.getItem('popup')
      var popupTimeNext = new Date(new Date(popup).setDate(new Date(popup).getDate() + this.generalInfo.popup.showModel));
      if(popup === null || popupTimeNext < new Date() )
      setTimeout(()=>{
        localStorage.setItem('popup',new Date())
        this.popupActive = true;
      },2500)
    }
    this.getFirebaseTokenMessage();
    this.interval = setInterval(() => {
      this.getInfo();
    },60000);
    /*
   this.$echo.private('user.' + this.activeUserInfo.id).listen('User.getUser', (payload) => {
     this.$store.commit('UPDATE_USER_INFO', payload.user, {root: true})
   });

   this.$echo.channel('channel-message').listen('NewMessage', (payload) => {
     console.log(payload);
     this.$vs.notify({
       title: 'success',
       text: payload.message,
       iconPack: 'feather',
       icon: 'icon-alert-circle',
       color: 'success'
     })
   });
    */
  },
  computed: {
    time(){
      if(this.gift.expired_at){
        const now = new Date()
        const expired_at =  new Date(this.gift.expired_at)
        return expired_at - now
      }else
        return null;
    },
    alertList(){
      var alertRemoved = localStorage.getItem('alertRemoved') !== null ? JSON.parse(localStorage.getItem('alertRemoved')) : [];
      var alerts = [];
      this.generalInfo.alert.list.map((item,key)=>{
        var alertIndex = alertRemoved.findIndex(x => x.title === item.title && x.msg === item.msg  && x.color === item.color );
        if(alertIndex === -1){
          alerts.push(item);
        }
      })
      return alerts;
    }
  },
  watch:{
    alertListActive(value){
      var alertRemoved = localStorage.getItem('alertRemoved') !== null ? JSON.parse(localStorage.getItem('alertRemoved')) : [];
      this.generalInfo.alert.list.map((item,key)=>{
        var alertIndex = alertRemoved.findIndex(x => x.title === item.title && x.msg === item.msg  && x.color === item.color );
        if(!value[key] && alertIndex === -1){
          alertRemoved.push(item);
        }
      })
      localStorage.setItem('alertRemoved',JSON.stringify(alertRemoved))
    }
  },
  created () {
    if(localStorage.getItem('dashboard') !== null){
      var data = JSON.parse(localStorage.getItem('dashboard'));
      if(data.id === this.activeUserInfo.id)
        this.setData(data);
    }

    this.generalInfo.alert.list.map(item=>{
      this.alertListActive.push(true)
    })
    this.getInfo();
  },
  beforeDestroy() {
    window.clearInterval(this.interval)
  },
}
</script>

<style lang="scss">


/*! rtl:begin:ignore */
#dashboard {

  #level-info table {
    td {
      vertical-align: top;
      min-width: 200px;
      padding-bottom: .8rem;
      padding-top: .8rem;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:500px) {
          display: block;
        }
      }
    }
  }

  .w-130 .vs-table-text{
    min-width: 120px;
  }
  .w-150 .vs-table-text{
    min-width: 150px;
  }
  .w-75 .vs-table-text{
    min-width: 75px;
  }

  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }

    #level-info table tr{
      td:nth-child(odd){
        padding-bottom: 5px !important;
      }
      td:nth-child(even){
        padding-top: 0px !important;
        text-align: left;
      }
    }
  }
}
#popup img{
  max-width: 100%;
}
/*! rtl:end:ignore */
</style>
